<p-toast [style]="{marginTop: '80px'}" position="top-right" key="msj"></p-toast>
<p-toast position="top-center" key="confirm" (onClose)="cancelarMensajeConfirmacion()" [baseZIndex]="5000">
  <ng-template let-message pTemplate="message">
    <div class="flex flex-column" style="flex: 1">
      <div class="text-center">
        <i class="pi pi-exclamation-triangle" style="font-size: 3rem"></i>
        <h4>{{message.summary}}</h4>
        <p>{{message.detail}}</p>
      </div>
      <div class="grid p-fluid">
        <div class="col-6">
          <button type="button" pButton (click)="cancelarMensajeConfirmacion()" label="Cancelar"
            class="p-button-secondary"></button>
        </div>
        <div class="col-6">
          <button type="button" pButton (click)="confirmarMensaje()" label="Aceptar" class="p-button-success"></button>
        </div>
      </div>
    </div>
  </ng-template>
</p-toast>
<p-confirmDialog [style]="{width: '50vw'}" [baseZIndex]="10000" acceptLabel="Aceptar" rejectLabel="Cancelar"
  rejectButtonStyleClass="p-button-text"></p-confirmDialog>
<p-confirmDialog [style]="{width: '50vw'}" key="sinInformacionDialog" [baseZIndex]="10000" acceptLabel="Aceptar"
  rejectLabel="Cancelar" rejectButtonStyleClass="p-button-text" styleClass="color-confirmar"
  [rejectVisible]="false"></p-confirmDialog>
<div class="d-flex justify-content-center">
  <div class="container-fluid" style="width: 98%;">
    <div class="row mt-5">
      <div class="col-md-12">
        <div class="card card-shadow sinborde">
          <div class="card-header sinborde" style="background: none; ">
            <div class="cardicono rounded">
              <i class="pi pi-car mt-3" style="font-size: 2rem; color: #fff;"></i>
            </div>
            <!--<header style="left: 5%; top: 5%;">Listado de Unidades</header>-->
            <div class="row d-flex justify-content-end">
              <div class="col-2">
                <button type="button" class="btn btn-success" style="width: 100%;" (click)="abrirModalReportes()"
                  pTooltip="Abrir Ventana" tooltipPosition="left">
                  Reportes <i class="pi pi-file-excel"></i>
                </button>
              </div>
              <div class="col-2">
                <button type="button" class="btn btn-primary" style="width: 100%;" (click)="redireccionarNueva(1);"
                  pTooltip="Agregar nueva Unidad de Transporte" tooltipPosition="bottom">
                  Agregar <i class="pi pi-plus-circle"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="card-content">
            <div class="row mt-3">
              <p-table #dt1 [value]="lstUnidades" [tableStyle]="{'min-width': '50rem'}"
                styleClass="p-datatable-sm p-datatable-striped" [scrollable]="true" scrollHeight="580px"
                [globalFilterFields]="['num_economico','desc_placaUnidad','nombre_tipounidad','nombre_tipotransporte','nombre_configuracionunidad','nombre_ciudaddestino','desc_marca',
                                'desc_modelo','vin']" [paginator]="true" [rows]="50"
                [rowsPerPageOptions]="[25,50,100,150,200]" [loading]="loading" [showCurrentPageReport]="true"
                [resizableColumns]="false" currentPageReportTemplate=" {first} a {last} de {totalRecords} Registros">
                <ng-template pTemplate="caption">
                  <div class="flex">
                    <p class="mr-2 ml-5 fs-2 color-header">Listado de Unidades de Transporte</p>
                    <div class="ml-5">
                      <p-columnFilter field="clv_estatus" matchMode="equals" [showMenu]="false">
                        <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                          <p-dropdown [ngModel]="value" [options]="lstEstatus" optionLabel="nombre" optionValue="id"
                            (onChange)="filter($event.value)" placeholder="Filtrar por Estatus" [showClear]="true">
                          </p-dropdown>
                        </ng-template>
                      </p-columnFilter>
                    </div>
                    <span class="p-input-icon-left ml-auto">
                      <i class="pi pi-search"></i>
                      <input pInputText type="text" size="40" (input)="applyFilterGlobal($event, 'contains')"
                        placeholder="Buscar Economico,Transporte,Ciudad,Unidad" />
                    </span>
                  </div>
                  <!--<div class="flex flex-row-reverse flex-wrap">
                                        <span class="p-input-icon-left p-ml-auto">
                                            <i class="pi pi-search"></i>
                                            <input pInputText type="text" size="40"
                                                (input)="applyFilterGlobal($event, 'contains')" placeholder="Buscar" />
                                        </span>
                                    </div>-->
                </ng-template>
                <ng-template pTemplate="header">
                  <tr>
                    <th pSortableColumn="num_economico" class="text-center" [ngClass]="{'texto_sm':true}">#Economico
                      <p-sortIcon field="num_economico"></p-sortIcon>
                    </th>
                    <th pSortableColumn="desc_placaUnidad" [ngClass]="{'texto_sm':true}">
                      Placa<p-sortIcon field="desc_placaUnidad"></p-sortIcon>
                    </th>




                    <th style="min-width:180px ;max-width: 180px;" [ngClass]="{'texto_sm':true}">
                      Descripci&oacute;n</th>
                    <th pSortableColumn="num_kilometraje_mantenimiento" style="min-width:120px ;max-width: 120px;"
                      [ngClass]="{'texto_sm':true}">Kilómetros
                      <p-sortIcon field="num_kilometraje_mantenimiento"></p-sortIcon>
                    </th>

                    <th style="min-width:150px ;max-width: 150px;" [ngClass]="{'texto_sm':true}">VIN
                    </th>
                    <th pSortableColumn="num_rendimiento_objetivo" class="text-center"
                      style="min-width:150px ;max-width: 150px;" [ngClass]="{'texto_sm':true}">
                      Rendimiento<p-sortIcon field="num_rendimiento_objetivo"></p-sortIcon>
                    </th>
                    <th pSortableColumn="nombre_configuracionunidad" class="text-center" [ngClass]="{'texto_sm':true}">
                      Tipo
                      <p-sortIcon field="nombre_configuracionunidad"></p-sortIcon>
                    </th>
                    <th pSortableColumn="nombre_tipounidad" class="text-center"
                      style="min-width:160px ;max-width: 160px;" [ngClass]="{'texto_sm':true}">
                      Unidad<p-sortIcon field="nombre_tipounidad"></p-sortIcon>
                    </th>
                    <th pSortableColumn="nombre_ciudaddestino" class="text-center"
                      style="min-width:160px ;max-width: 160px;" [ngClass]="{'texto_sm':true}">
                      Ciudad
                      Operaci&oacute;n<p-sortIcon field="nombre_ciudaddestino"></p-sortIcon>
                    </th>
                    <th pSortableColumn="desc_estatus" class="text-center" style="min-width: 230px;max-width: 230px;"
                      [ngClass]="{'texto_sm':true}">
                      Estatus/Sub-Estatus
                      <p-sortIcon field="desc_estatus"></p-sortIcon>
                    </th>
                    <th style="min-width:180px;max-width: 180px;"></th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-unidad>
                  <tr
                    [ngClass]="{'row-accessories': unidad.clv_estatus===0,'row-baja': unidad.clv_estatus==3,'texto_sm':true}">
                    <td [ngClass]="{'color-numeconomico':true}">
                      <p class="text-center">{{unidad.num_economico}}</p>
                    </td>
                    <td [ngClass]="{'color-sombreado':true}">{{unidad.desc_placaUnidad}}</td>
                    <td [ngClass]="{'ajustarcelda':true}">{{ unidad.desc_marca +' '+
                      unidad.desc_modelo + ' '+unidad.desc_color}}<p [ngClass]="{'color-sombreado':true}"
                        style="display: inline;">
                        -{{unidad.num_anio}}</p>
                    </td>
                    <td><b>{{unidad.num_kilometraje_mantenimiento}}</b></td>
                    <td>{{unidad.vin}}</td>
                    <td class="text-center texto-pesado">{{unidad.num_rendimiento_objetivo}}</td>
                    <td class="text-center">{{unidad.nombre_configuracionunidad}}</td>
                    <td class="text-center">{{unidad.nombre_tipounidad}}</td>
                    <td class="text-center">{{unidad.nombre_ciudaddestino}}</td>
                    <td class="text-center" *ngIf="unidad.clv_estatus == 1||unidad.clv_estatus == 4">{{unidad.desc_estatus}}</td>
                    <td class="text-center" *ngIf="unidad.clv_estatus == 0||unidad.clv_estatus == 3">{{unidad.desc_estatus +' - '+ unidad.desc_sub_estatus}}</td>
                    <td >
                      <div class="btnGrp">
                    <!-- <td class="d-flex justify-content-center align-items-center">
                      <div class="d-flex gap-3 justify-content-center"> -->
                        <p-button 
                          styleClass="p-button-warning p-button-sm" 
                          pTooltip="Editar Informacion de Unidad" tooltipPosition="top"
                          (click)="editarInformacion(unidad,2);"
                          icon="pi pi-pencil"/>
                        <p-button
                          styleClass="p-button-info p-button-sm"
                          pTooltip="Gestionar Estatus de Unidad" tooltipPosition="top"
                          (click)="mostrarDialogoEstatus(unidad);"
                          icon="pi pi-delete-left">
                        </p-button>
                        <p-button 
                          styleClass="p-button-sm"
                          [style]="{'background-color':'blueviolet','border-color': 'blueviolet'}"
                          pTooltip="Herramientas de Recursos" tooltipPosition="top"
                          (click)="gestionarHerramientas(unidad);"
                          icon="pi pi-cog">
                          <!-- <i class="pi pi-cog"></i> -->
                        </p-button>
                        <!-- <p-button 
                          class="btn btn-secondary" 
                          style="background-color:blueviolet;border-color: blueviolet;"
                          pTooltip="Herramientas de Recursos" tooltipPosition="top"
                          (click)="gestionarHerramientas(unidad);"
                          icon="pi pi-cog">
                          <i class="pi pi-cog"></i>
                        </p-button> -->
                        <!-- <p-button styleClass="p-button-help p-button-sm" icon="pi pi-cog"
                          pTooltip="Herramientas de Recursos" tooltipPosition="top"
                          (click)="gestionarHerramientas(unidad);">
                        </p-button> -->
                                          
                        <p-splitButton
                          styleClass="p-button-secondary p-button-sm mi-splitbutton"
                          icon="pi pi-wrench"
                          [model]="itemsMtto"
                          [appendTo]="'body'"
                          (onClick)="herrMantenimiento(unidad)"
                          (onDropdownClick)="herrMantenimiento(unidad)"
                          pTooltip="Herramientas Mantenimiento"
                        />
                        <!-- <button class="btn btn-secondary" pTooltip="Mantenimiento" tooltipPosition="top"
                          [style]="{'overflow':'true'}"
                          (click)="historialKilometraje(unidad);">
                          <i class="pi pi-wrench"></i>
                        </button> -->
                        <p-button 
                          styleClass="p-button-success p-button-sm"
                          pTooltip="Actualizar Centro de Costos" tooltipPosition="top"
                          (click)="actualizarCiudad(unidad);"   
                          icon="pi pi-file-edit">
                        </p-button>
                      </div>
                    </td>
                  </tr>
                </ng-template>
                <!--<ng-template pTemplate="summary">
                                    <div class="flex align-items-center justify-content-between">
                                        Un total de {{lstUnidadesTransporte ? lstUnidadesTransporte.length : 0 }}
                                        Registros.
                                    </div>
                                </ng-template>-->
              </p-table>
            </div>
            <div class="row mt-3 d-flex justify-content-center">
              <div class="col-6">
                <div class="text-center">
                  <p-colorPicker [(ngModel)]="color_gris_deshabilitadas" [disabled]="true"></p-colorPicker>
                  <p class="text-left informativo" style="display: inline;">
                    Inactiva</p>
                </div>
              </div>
            </div>
            <div class="row mt-3 d-flex justify-content-center">
              <div class="col-6">
                <div class="text-center">
                  <p-colorPicker [(ngModel)]="color_naranja_baja" [disabled]="true"></p-colorPicker>
                  <p class="text-left informativo" style="display: inline;">
                    Baja de Operación</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--Actualizar Ciudad-->
    <p-dialog [resizable]="false" [draggable]="false" [(visible)]="dspActualizarCiudad"
    [style]="{'width': '55vw','height':'500px'}" (onHide)="CancelarActualizar()"
    [transitionOptions]="'0ms'" styleClass="card-shadow">
    <ng-template pTemplate="header">
        Actualizar el Centro de Costos
    </ng-template>
      <ng-template pTemplate="content">
        <form [formGroup]="formularioActualizarCiudad">
        <div class="row pb-2">
            <div class="row mt-1 d-flex justify-content-start">
                <div class="col-sm-6">
                    <span class="title-light">Agregue la información solicitada
                        <i class="pi pi-cog" style="size: 2rem;"></i>
                    </span>
                </div>
            </div>
            <!-- Ciudad Actual -->
            <div class="col-md-6 mt-3">
                <div class="row g-0">
                    <div class="col-sm-6 d-flex align-items-center">
                        <span class="input-group-addon">
                            <i class="pi pi-map-marker color-icon" style="font-size: 1.5rem"></i>
                            <p class="ml-1 d-inline" style="color: #1e5a9c;"><b>Ciudad Actual</b></p>
                        </span>
                    </div>
                    <div class="mt-2">
                      <p-dropdown [options]="lstCiudades" autoWidth="false" [style]="{'width':'100%'}"
                      placeholder="Ciudad ACtual" optionLabel="nombre" [showClear]="true" [disabled]="true"
                      formControlName="ciudadActual" optionValue="id" tooltip="Ciudad Actual"></p-dropdown>
                        <hr style="border: none; border-top: 2px solid #1e5a9c; font-weight: bold;" class="my-0">
                    </div>
                </div>
            </div>

            <!-- Nueva Ciudad -->
            <div class="col-md-6 mt-3">
              <div class="row g-0">
                  <div class="col-sm-6 d-flex align-items-center">
                      <span class="input-group-addon">
                          <i class="pi pi-map-marker color-icon" style="font-size: 1.5rem"></i>
                          <p class="ml-1 d-inline" style="color: #1e5a9c;"><b>Nueva Ciudad</b></p>
                      </span>
                  </div>
                  <div class="mt-2">
                    <p-dropdown [options]="lstCiudadesMod" autoWidth="false" [style]="{'width':'100%'}"
                    placeholder="Seleccione la nueva ciudad" optionLabel="nombre" [showClear]="true"
                    formControlName="ciudadNueva" optionValue="id" tooltip="Seleccione la nueva ciudad"></p-dropdown>
                      <hr style="border: none; border-top: 2px solid #1e5a9c; font-weight: bold;" class="my-0">
                  </div>
              </div>
          </div>

            <!-- Fecha de Movimiento -->
            <div class="col-md-6 mt-5">
                <label style="color: #1e5a9c; font-weight: bold;">Fecha de Movimiento</label>
                <p-calendar
                [appendTo]="'body'"
                formControlName="fecha_movimiento"
                [showIcon]="true"
                dateFormat="dd/mm/yy"
                [showTime]="false"
                >
              </p-calendar>
            </div>

        </div>

        <!-- Botón Actualizar -->
        <div class="mt-4 d-flex justify-content-center">
            <button type="button" class="p-button p-button-success" (click)="GuardarActualizarCiudad()">
                <b>Actualizar</b>
            </button>
        </div>
      </form>
    </ng-template>


    <ng-template pTemplate="footer">
        <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text"
            (click)="CancelarActualizar();"></button>
    </ng-template>
</p-dialog>
    <!--EDICION DE INFORMACION-->
    <p-dialog [resizable]="false" [draggable]="false" [(visible)]="dspEditar" [style]="{'width': '70vw'}"
      [transitionOptions]="'0ms'" styleClass="card-shadow" [closeOnEscape]="false">
      <ng-template pTemplate="header">
        {{texto_operacion}}
      </ng-template>
      <ng-template pTemplate="content">
        <div class="card-content">
          <form class="form_unidad" [formGroup]="formularioUnidad" (ngSubmit)="submit()">
            <div>
              <span class="title-light">Datos Principales <i class="pi pi-cog" style="size: 2rem;"></i></span>
              <div class="row pb-2">
                <div class="form-group col-md-6">
                  <div class="row g-0">
                    <div class="col-sm-1 mx-0">
                      <span class="input-group-addon"> <i class="pi pi-align-justify color-icon"
                          style="font-size: 2rem"></i>
                      </span>
                    </div>
                    <div class="col-sm-11">
                      <p-dropdown [options]="lstTransporte" optionLabel="nombre" autoWidth="false"
                        [style]="{'width':'100%'}" [showClear]="true" formControlName="clave_tipoTransporte"
                        optionValue="clave_tipoTransporte" placeholder="Seleccione Tipo Transporte*"
                        pTooltip="Tipo Transporte" tooltipPosition="left"></p-dropdown>
                      <hr class="my-0">
                    </div>
                  </div>
                </div>
                <div class="form-group row col-md-6">
                  <div class="form-group col-md-12">
                    <div class="row g-0">
                      <div class="col-sm-1 mx-0">
                        <span class="input-group-addon"> <i class="pi pi-align-justify color-icon"
                            style="font-size: 2rem"></i>
                        </span>
                        <!-- <small class="color-icon mt-3 ml-2"
                        style="display: inline-block; font-weight: bold;">Unidad</small> -->
                      </div>
                      <div class="col-sm-11">
                        <p-dropdown [options]="lstConfUnidad" optionLabel="nombre"
                          formControlName="clave_configuracionUnidad" optionValue="clave_configuracionUnidad"
                          autoWidth="false" [style]="{'width':'100%'}" placeholder="Seleccione Unidad*"
                          pTooltip="Unidad"></p-dropdown>
                        <hr class="my-0">
                      </div>
                    </div>
                  </div>

                </div>
              </div>
              <div class="row pb-2">
                <div class="form-group col-md-6">
                  <div class="row g-0">
                    <div class="col-sm-1 mx-0">
                      <span class="input-group-addon"> <i class="pi pi-align-justify color-icon"
                          style="font-size: 2rem"></i>
                      </span>
                    </div>
                    <div class="col-sm-11">
                      <p-dropdown [options]="lstTipoUnidad" optionLabel="nombre" formControlName="clave_tipoUnidad"
                        optionValue="clave_tipoUnidad" autoWidth="false" [style]="{'width':'100%'}"
                        placeholder="Seleccione Tipo Unidad*" (ngModelChange)="validarCambioTipoUnidad()"
                        pTooltip="Tipo Unidad" tooltipPosition="left"></p-dropdown>
                      <hr class="my-0">
                    </div>
                  </div>
                </div>
                <div class="form-group col-md-6">
                  <div class="row g-0">
                    <div class="col-sm-1">
                      <span class="input-group-addon"> <i class="pi pi-book color-icon" style="font-size: 2rem"></i>
                      </span>
                    </div>
                    <div class="col-sm-11">
                      <input type="text" class="form-control sinborde" placeholder="Numero Económico*"
                        formControlName="num_economico" style="text-transform:uppercase; color: blueviolet;"
                        (keyup.enter)="validarNumeroEconomico()" (keyup.Space)="validarNumeroEconomico()"
                        (keyup.shift)="validarNumeroEconomico()" (keyup)="validarNumeroEconomicoAlTeclear()"
                        style="text-transform:uppercase;" pTooltip="Numero Economico" tooltipPosition="top">
                      <hr class="my-0">
                    </div>

                  </div>
                </div>
              </div>
              <div class="row pb-2">
                <div class="form-group col-md-6">
                  <div class="row g-0">
                    <div class="col-sm-1">
                      <span class="input-group-addon"> <i class="pi pi-align-justify color-icon"
                          style="font-size: 2rem"></i>
                      </span>
                    </div>
                    <div class="col-sm-11">
                      <p-dropdown [options]="lstTipoVerificacion" autoWidth="false" [style]="{'width':'100%'}"
                        formControlName="clave_tipoverificacion" optionValue="clave_tipoverificacion"
                        placeholder="Seleccione Tipo de Placa*" optionLabel="nombre" [showClear]="true"
                        pTooltip="Tipo de Placa" tooltipPosition="left"></p-dropdown>
                      <hr class="my-0">
                    </div>
                  </div>
                </div>
                <div class="form-group col-md-6">
                  <div class="row g-0">
                    <div class="col-sm-1">
                      <span class="input-group-addon"> <i class="pi pi-book color-icon" style="font-size: 2rem"></i>
                      </span>
                    </div>
                    <div class="col-sm-11">
                      <input type="text" class="form-control sinborde" placeholder="Placa*"
                        formControlName="desc_placaUnidad" style="text-transform:uppercase;" pTooltip="Placa">
                      <hr class="my-0">
                    </div>
                  </div>
                </div>
              </div>
              <div class="row pb-2">
                <div class="form-group col-md-6">
                  <div class="row g-0">
                    <div class="col-sm-1">
                      <span class="input-group-addon"> <i class="pi pi-align-justify color-icon"
                          style="font-size: 2rem"></i>
                      </span>
                    </div>
                    <div class="col-sm-11">
                      <p-dropdown [options]="lstEstado" autoWidth="false" [style]="{'width':'100%'}"
                        formControlName="clave_Estado" optionValue="clave_Estado"
                        placeholder="Seleccione Estado de Tarjeta*" optionLabel="nombre" [showClear]="true"
                        pTooltip="Estado de Tarjeta" tooltipPosition="left"></p-dropdown>
                      <hr class="my-0">
                    </div>
                  </div>
                </div>
                <div class="form-group col-md-6">
                  <div class="row g-0">
                    <div class="col-sm-1">
                      <span class="input-group-addon"> <i class="pi pi-book color-icon" style="font-size: 2rem"></i>
                      </span>
                    </div>
                    <div class="col-sm-5">
                      <input type="text" class="form-control sinborde" placeholder="Tarjeta de Circulación*"
                        formControlName="num_tarjetaCirculacion" style="text-transform:uppercase;"
                        pTooltip="Tarjeta de Circulación">
                      <hr class="my-0">
                    </div>
                    <div class="col-sm-1">
                      <span class="input-group-addon"> <i class="pi pi-book color-icon" style="font-size: 2rem"></i>
                      </span>
                    </div>
                    <div class="col-sm-5">
                      <input type="date" class="form-control sinborde" pTooltip="Vigente Hasta" tooltipPosition="top"
                        formControlName="fec_vigencia_tarjeta" style="text-transform:uppercase;">
                      <hr class="my-0">
                    </div>
                  </div>
                </div>
              </div>
              <div class="row pb-2">
                <div class="form-group col-md-6">
                  <div class="row g-0">
                    <div class="col-sm-1">
                      <span class="input-group-addon"> <i class="pi pi-align-justify color-icon"
                          style="font-size: 2rem"></i>
                      </span>
                    </div>
                    <div class="col-sm-11">
                      <p-dropdown [options]="lstVerificaciones" autoWidth="false" [style]="{'width':'100%'}"
                        formControlName="clave_verificacion" optionValue="clave_verificacion"
                        placeholder="Verificación Estado" optionLabel="nombre" [showClear]="true"
                        pTooltip="Verificacion Estado" tooltipPosition="left"
                        (ngModelChange)="validarCambioEstado()"></p-dropdown>
                      <hr class="my-0">
                    </div>
                  </div>
                </div>
                <div class="form-group col-md-6">
                  <div class="row g-0">
                    <div class="col-sm-6 d-flex justify-content-around">
                      <label class="label-header">Fecha Inicio*</label>
                      <input type="date" class="form-control sinborde"
                        pTooltip="Seleccione o teclee fecha Inicio de Estado" tooltipPosition="top"
                        formControlName="fec_inicio_estatal" style="text-transform:uppercase;">
                    </div>
                    <div class="col-sm-6 d-flex justify-content-around">
                      <label class="label-header">Fecha Fin*</label>
                      <input type="date" class="form-control sinborde"
                        pTooltip="Seleccione o teclee fecha Fin de Estado" tooltipPosition="top"
                        formControlName="fec_fin_estatal" style="text-transform:uppercase;">
                        <hr class="my-0">
                    </div>
                  </div>
                </div>
              </div>
              <div class="row pb-2">
                <div class="form-group col-md-6">
                  <div class="row g-0">
                    <div class="col-sm-1">
                      <span class="input-group-addon"> <i class="pi pi-align-justify color-icon"
                          style="font-size: 2rem"></i>
                      </span>
                    </div>
                    <div class="col-sm-11">
                      <p-dropdown [options]="lstVerificacionHumo" autoWidth="false" [style]="{'width':'100%'}"
                        formControlName="clv_humo" optionValue="id" placeholder="Verificación Humo" optionLabel="nombre"
                        [showClear]="true" pTooltip="Verificacion Humo" (ngModelChange)="validarCambioHumo()"
                        tooltipPosition="left"></p-dropdown>
                      <hr class="my-0">
                    </div>
                  </div>
                </div>
                <div class="form-group col-md-6">
                  <div class="row g-0">
                    <div class="col-sm-6 d-flex justify-content-around">
                      <label class="label-header">Fecha Inicio*</label>
                      <input type="date" class="form-control sinborde"
                        pTooltip="Seleccione o teclee fecha Inicio de Humo" tooltipPosition="top"
                        formControlName="fec_inicio_humo" style="text-transform:uppercase;">
                    </div>
                    <div class="col-sm-6 d-flex justify-content-around">
                      <label class="label-header">Fecha Fin*</label>
                      <input type="date" class="form-control sinborde" pTooltip="Seleccione o teclee fecha Fin de Humo"
                        tooltipPosition="top" formControlName="fec_fin_humo" style="text-transform:uppercase;">
                        <hr class="my-0">
                    </div>

                  </div>
                </div>
                
              </div>
              <div class="row pb-2">
                <div class="form-group col-md-6">
                  <div class="row g-0">
                    <div class="col-sm-1">
                      <span class="input-group-addon"> <i class="pi pi-align-justify color-icon"
                          style="font-size: 2rem"></i>
                      </span>
                    </div>
                    <div class="col-sm-11">
                      <p-dropdown [options]="lstVerificacionFisico" autoWidth="false" [style]="{'width':'100%'}"
                        formControlName="clv_fisico" optionValue="id" placeholder="Verificación Fisico-Mecanica"
                        optionLabel="nombre" [showClear]="true" pTooltip="Verificacion Fisico-Mecanica"
                        tooltipPosition="left" (ngModelChange)="validarCambioFisico()"></p-dropdown>
                      <hr class="my-0">
                    </div>
                  </div>
                </div>
                <div class="form-group col-md-6">
                  <div class="row g-0">
                    <div class="col-sm-6 d-flex justify-content-around">
                      <label class="label-header">Fecha Inicio*</label>
                      <input type="date" class="form-control sinborde"
                        pTooltip="Seleccione o teclee fecha Inicio de Fisico" tooltipPosition="top"
                        formControlName="fec_inicio_mecanica" style="text-transform:uppercase;">
                    </div>
                    <div class="col-sm-6 d-flex justify-content-around">
                      <label class="label-header">Fecha Fin*</label>
                      <input type="date" class="form-control sinborde"
                        pTooltip="Seleccione o teclee fecha Fin de Fisico" tooltipPosition="top"
                        formControlName="fec_fin_mecanica" style="text-transform:uppercase;">
                        <hr class="my-0">

                    </div>

                  </div>
                </div>
              </div>
              <div class="row pb-2" *ngIf="formularioUnidad.value.clave_tipoUnidad==2">
                <div class="form-group col-md-6">
                  <div class="row g-0">
                    <div class="col-sm-1">
                      <span class="input-group-addon"> <i class="pi pi-align-justify color-icon"
                          style="font-size: 2rem"></i>
                      </span>
                    </div>
                    <div class="col-sm-11">
                      <p-dropdown [options]="lstproveedor" optionLabel="nombre" formControlName="clave_proveedor"
                        optionValue="clave_proveedor" (onChange)="seleccionarProveedor()" autoWidth="false"
                        [style]="{'width':'100%'}" placeholder="Seleccione Proveedor*" [showClear]="true"
                        pTooltip="Proveedor"></p-dropdown>
                      <hr class="my-0">
                    </div>
                  </div>
                </div>
                <div class="form-group col-md-6">
                  <div class="row g-0">
                    <div class="col-sm-6 d-flex justify-content-around">
                      <label class="label-header">Fecha Inicio*</label>
                      <input type="date" class="form-control sinborde" formControlName="fecha_inicioRenta"
                        pTooltip="Seleccione o teclee fecha Inicio de Renta" tooltipPosition="top"
                        style="text-transform:uppercase;">
                      <hr class="my-0">
                    </div>
                    <div class="col-sm-6 d-flex justify-content-around">
                      <label class="label-header">Fecha Fin</label>
                      <input type="date" class="form-control sinborde" formControlName="fecha_finRenta"
                        pTooltip="Seleccione o teclee fecha fin de Renta" tooltipPosition="top"
                        style="text-transform:uppercase;">
                      <hr class="my-0">
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <span class="title-light">Generales y Caracteristicas <i class="pi pi-check-square"
                  style="size: 2rem;"></i></span>
            </div>
            <div class="row pb-2">
              <div class="form-group col-md-6">
                <div class="row g-0">
                  <div class="col-sm-1">
                    <span class="input-group-addon"> <i class="pi pi-book color-icon" style="font-size: 2rem"></i>
                    </span>
                  </div>
                  <div class="col-sm-11">
                    <input type="text" class="form-control sinborde" placeholder="VIN" formControlName="vin"
                      style="text-transform:uppercase;" pTooltip="VIN">
                    <hr class="my-0">
                  </div>
                </div>
              </div>
            </div>
            <div class="row pb-2">
              <div class="form-group col-md-6">
                <div class="row">
                  <div class="col-sm-1">
                    <span class="input-group-addon"> <i class="pi pi-book color-icon" style="font-size: 2rem"></i>
                    </span>
                  </div>
                  <div class="col-sm-11">
                    <input type="text" class="form-control sinborde" placeholder="Marca*" formControlName="desc_marca"
                      style="text-transform:uppercase;" pTooltip="Marca">
                    <hr class="my-0">
                  </div>
                </div>
              </div>
              <div class="form-group col-md-6">
                <div class="row">
                  <div class="col-sm-1">
                    <span class="input-group-addon"> <i class="pi pi-book color-icon" style="font-size: 2rem"></i>
                    </span>
                  </div>
                  <div class="col-sm-11">
                    <input type="text" class="form-control sinborde" placeholder="Modelo*" formControlName="desc_modelo"
                      style="text-transform:uppercase;" pTooltip="Modelo">
                    <hr class="my-0">
                  </div>
                </div>
              </div>
            </div>
            <div class="row pb-2">
              <div class="form-group col-md-6">
                <div class="row">
                  <div class="col-sm-1">
                    <span class="input-group-addon"> <i class="pi pi-book color-icon" style="font-size: 2rem"></i>
                    </span>
                  </div>
                  <div class="col-sm-11">
                    <input type="text" class="form-control sinborde" placeholder="Año*" formControlName="num_anio"
                      style="text-transform:uppercase;" pTooltip="Año">
                    <hr class="my-0">
                  </div>
                </div>
              </div>
              <div class="form-group col-md-6">
                <div class="row">
                  <div class="col-sm-1">
                    <span class="input-group-addon"> <i class="pi pi-book color-icon" style="font-size: 2rem"></i>
                    </span>
                  </div>
                  <div class="col-sm-11">
                    <input type="text" class="form-control sinborde" placeholder="Color*" formControlName="desc_color"
                      style="text-transform:uppercase;" pTooltip="Color">
                    <hr class="my-0">
                  </div>
                </div>
              </div>
            </div>
            <div class="row pb-2">
              <div class="form-group col-md-6">
                <div class="row g-0">
                  <div class="col-sm-1">
                    <span class="input-group-addon"> <i class="pi pi-align-justify color-icon"
                        style="font-size: 2rem"></i>
                    </span>
                  </div>
                  <div class="col-sm-11">
                    <input type="text" class="form-control sinborde" placeholder="Poliza de Seguro*"
                      formControlName="num_polizaSeguro" style="text-transform:uppercase;" pTooltip="Poliza de Seguro">
                    <hr class="my-0">
                  </div>
                </div>
              </div>
              <div class="form-group col-md-6">
                <div class="row g-0">
                  <div class="col-sm-6 d-flex justify-content-around">
                    <label class="label-header">Fecha Inicio*</label>
                    <input type="date" class="form-control sinborde"
                      pTooltip="Seleccione o teclee fecha Inicio de Poliza" tooltipPosition="top"
                      formControlName="fecha_inicioPoliza" style="text-transform:uppercase;">

                  </div>
                  <div class="col-sm-6 d-flex justify-content-around">
                    <label class="label-header">Fecha Fin*</label>
                    <input type="date" class="form-control sinborde" pTooltip="Seleccione o teclee fecha Fin de Poliza"
                      tooltipPosition="top" formControlName="fecha_finPoliza" style="text-transform:uppercase;">
                    <hr class="my-0">

                  </div>

                </div>
              </div>
            </div>
            <div class="row pb-2">
              <div class="form-group col-md-6">
                <div class="row">
                  <div class="col-sm-1">
                    <span class="input-group-addon"> <i class="pi pi-book color-icon" style="font-size: 2rem"></i>
                    </span>
                  </div>
                  <div class="col-sm-11">
                    <p-dropdown [options]="lstAsegSCT" autoWidth="false" [style]="{'width':'100%'}"
                    placeholder="Aseguradora" optionLabel="nombre_aseguradora" [showClear]="true"
                    formControlName="id_aseguradora" optionValue="id" tooltip="Aseguradora"
                    tooltipPosition="top"></p-dropdown>
                    <hr class="my-0">
                  </div>
                </div>
              </div>
            </div>
            <div class="row pb-2">
              <div class="form-group col-md-6">
                <div class="row">
                  <div class="col-sm-1">
                    <span class="input-group-addon"> <i class="pi pi-book color-icon" style="font-size: 2rem"></i>
                    </span>
                  </div>
                  <div class="col-sm-11">
                    <input type="text" class="form-control sinborde" placeholder="Tipo de Caja"
                      formControlName="desc_tipoCaja" style="text-transform:uppercase;" pTooltip="Tipo de Caja">
                    <hr class="my-0">
                  </div>
                </div>
              </div>
              <div class="form-group col-md-6">
                <div class="row">
                  <div class="col-sm-1">
                    <span class="input-group-addon"> <i class="pi pi-book color-icon" style="font-size: 2rem"></i>
                    </span>
                  </div>
                  <div class="col-sm-11">
                    <input type="text" class="form-control sinborde" placeholder="Numero de Caja"
                      formControlName="num_caja" style="text-transform:uppercase;" pTooltip="Numero de Caja">
                    <hr class="my-0">
                  </div>
                </div>
              </div>
            </div>
            <div class="row pb-2">
              <div class="form-group col-md-6">
                <div class="row">
                  <div class="col-sm-1">
                    <span class="input-group-addon"> <i class="pi pi-align-justify color-icon"
                        style="font-size: 2rem"></i>
                    </span>
                  </div>
                  <div class="col-sm-11">
                    <p-dropdown [options]="lstCiudades" autoWidth="false" [style]="{'width':'100%'}"
                      placeholder="Seleccione Ciudad Destino" optionLabel="nombre" [showClear]="true"
                      formControlName="clave_ciudadDestino" optionValue="id" tooltip="Ciudad Destino"></p-dropdown>
                    <hr class="my-0">
                  </div>
                </div>
              </div>
              <div class="form-group col-md-6">
                <div class="row">
                  <div class="col-sm-1">
                    <span class="input-group-addon"> <i class="pi pi-align-justify color-icon"
                        style="font-size: 2rem"></i>
                    </span>
                  </div>
                  <div class="col-sm-11">
                    <p-dropdown [options]="lstCiudades" autoWidth="false" [style]="{'width':'100%'}"
                      placeholder="Seleccione Ciudad Origen" optionLabel="nombre" [showClear]="true"
                      formControlName="clave_ciudadOrigen" optionValue="id" tooltip="Ciudad Origen"
                      tooltipPosition="top"></p-dropdown>
                    <hr class="my-0">
                  </div>
                </div>
              </div>
            </div>
            <div class="row pb-2">
              <div class="form-group col-md-6">
                <div class="row">
                  <div class="col-sm-1">
                    <span class="input-group-addon"> <i class="pi pi-align-justify color-icon"
                        style="font-size: 2rem"></i>
                    </span>
                  </div>
                  <div class="col-sm-11">
                    <p-dropdown [options]="lstCombustible" autoWidth="false" [style]="{'width':'100%'}"
                      placeholder="Seleccione Tipo de Combustible" optionLabel="nombre" [showClear]="true"
                      formControlName="clave_tipo_combustible" optionValue="id"
                      tooltip="Tipo de Combustible"></p-dropdown>
                    <hr class="my-0">
                  </div>
                </div>
              </div>
            </div>
            <div>
              <span class="title-light">Medidas de Seguridad <i class="pi pi-lock" style="size: 2rem;"></i></span>
              <div class="row pb-2">
                <div class="form-group col-md-6">
                  <div class="row g-0">
                    <div class="col-sm-1"><span class="input-group-addon"> <i class="pi pi-book color-icon"
                          style="font-size: 2rem"></i>
                      </span></div>
                    <div class="col-sm-11">
                      <input type="text" placeholder="Numero GPS" class="form-control sinborde"
                        formControlName="num_gps" style="text-transform:uppercase;" pTooltip="Numero GPS">
                      <hr class="my-0">
                    </div>
                  </div>
                </div>
                <div class="form-group col-md-6">
                  <div class="row g-0">
                    <div class="col-sm-1"><span class="input-group-addon"> <i class="pi pi-book color-icon"
                          style="font-size: 2rem"></i>
                      </span></div>
                    <div class="col-sm-11">
                      <input type="text" placeholder="Nombre GPS" class="form-control sinborde"
                        formControlName="nombre_gps" style="text-transform:uppercase;" pTooltip="Nombre GPS">
                      <hr class="my-0">
                    </div>
                  </div>
                </div>
              </div>
              <div class="row pb-2">
                <div class="form-group col-md-6">
                  <div class="row">
                    <div class="col-sm-1"><span class="input-group-addon"> <i class="pi pi-book color-icon"
                          style="font-size: 2rem"></i>
                      </span></div>
                    <div class="col-sm-11">
                      <input type="text" placeholder="#Camara" class="form-control sinborde"
                        formControlName="num_camara" style="text-transform:uppercase;" pTooltip="#Camara">
                      <hr class="my-0">
                    </div>
                  </div>
                </div>
                <div class="form-group col-md-6">
                  <div class="row">
                    <div class="col-sm-1"><span class="input-group-addon"> <i class="pi pi-book color-icon"
                          style="font-size: 2rem"></i>
                      </span></div>
                    <div class="col-sm-11">
                      <input type="text" placeholder="#Boton Panico" class="form-control sinborde"
                        formControlName="num_boton_panico" style="text-transform:uppercase;" pTooltip="#Boton Panico">
                      <hr class="my-0">
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-md-6">
                  <div class="row">
                    <div class="col-sm-1"><span class="input-group-addon"> <i class="pi pi-book color-icon"
                          style="font-size: 2rem"></i>
                      </span></div>
                    <div class="col-sm-11">
                      <input type="text" placeholder="#Numero Inmovilizador" class="form-control sinborde"
                        formControlName="num_inmobilizador" style="text-transform:uppercase;"
                        pTooltip="#Numero Inmovilizador">
                      <hr class="my-0">
                    </div>
                  </div>
                </div>
                <div class="form-group col-md-6">
                  <div class="row">
                    <div class="col-sm-1"><span class="input-group-addon"> <i class="pi pi-book color-icon"
                          style="font-size: 2rem"></i>
                      </span></div>
                    <div class="col-sm-11">
                      <input type="text" placeholder="#Rendimiento Objetivo" class="form-control sinborde"
                        formControlName="num_rendimiento_objetivo" style="text-transform:uppercase;"
                        pTooltip="#Rendimiento Objetivo">
                      <hr class="my-0">
                    </div>
                  </div>
                </div>
              </div>
              <span class="title-light">Mantenimiento <i class="pi pi-wrench" style="size: 2rem;"></i></span>

              <div class="form-group col-md-6">
                <div class="row g-0">
                  <div class="col-sm-4 mx-0 d-flex align-items-center mt-2">
                    <span class="input-group-addon"> <i class="pi pi-map color-icon" style="font-size: 1.7rem"></i>
                    </span>
                    <small class="color-icon mt-3 ml-2"
                      style="display: inline-block; font-weight: bold;">Num.kilometros</small>
                  </div>
                  <div class="col-sm-8 mt-2">
                    <input type="number" class="form-control sinborde" pTooltip="Kilómetros de Mantenimiento"
                      tooltipPosition="top" placeholder="0" min="10000" formControlName="num_kilometraje_mantenimiento">

                    <hr class="my-0">
                  </div>
                </div>
              </div>

              <span class="title-light">Info Carta Porte  <i class="pi pi-file" style="size: 2rem;"></i></span>
              <div class="row">
                <div class="form-group col-md-6">
                  <div class="row">
                    <div class="col-sm-1">
                      <span class="input-group-addon"> 
                        <i class="pi pi-key color-icon"
                          style="font-size: 2rem"></i>
                      </span></div>
                    <div class="col-sm-11">
                        <p-dropdown [options]="lstPrmSCT" autoWidth="false" [style]="{'width':'100%'}"
                        placeholder="Clave Permiso SCT" optionLabel="clave" [showClear]="true"
                        formControlName="id_permiso_sct" optionValue="idx" tooltip="Clave Permiso SCT"
                        tooltipPosition="top"></p-dropdown>
                      <hr class="my-0">
                    </div>
                  </div>
                </div>
                <div class="form-group col-md-6">
                  <div class="row">
                    <div class="col-sm-4">
                      <span class="input-group-addon"> 
                        <i class="pi pi-tablet color-icon" style="font-size: 2rem"></i>
                        <small class="color-icon ml-2"
                        style="display: inline-block; font-weight: bold;">Num.PermisoSCT
                        </small>
                      </span>
                    </div>                      
                    <div class="col-sm-8">
                      <input type="text" placeholder="#Número Permiso SCT" class="form-control sinborde"
                        formControlName="num_permiso_sct" style="text-transform:uppercase;"
                        pTooltip="#Número Permiso SCT">
                      <hr class="my-0">
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-md-6 mt-2">
                  <div class="row">
                    <div class="col-sm-4">
                      <span class="input-group-addon"> 
                        <i class="pi pi-box color-icon"
                          style="font-size: 2rem"></i>
                        <small class="color-icon ml-2"
                        style="display: inline-block; font-weight: bold;">PesoBrutoVehicular
                        </small>
                      </span>
                    </div>
                    <div class="col-sm-8">
                      <input type="number" placeholder="Peso Bruto Vehicular(kg)" class="form-control sinborde"
                        formControlName="num_peso_bruto" style="text-transform:uppercase;"
                        pTooltip="Peso Bruto Vehicular(kg)" step="1">
                      <hr class="my-0">
                    </div>
                    <p class="mt-1 ml-2">
                      <i class="pi pi-info-circle texto-pesado-info">Peso Bruto en Kg. 1000kg = 1 Tonelada.</i>
                    </p>
                  </div>
                </div>
                <div class="form-group col-md-6">
                  <div class="row">
                    <div class="col-sm-1">
                      <span class="input-group-addon"> 
                        <i class="pi pi-cog color-icon"
                          style="font-size: 2rem"></i>
                      </span></div>
                    <div class="col-sm-11">
                      <p-dropdown [options]="lstCnfSCT" autoWidth="false" [style]="{'width':'100%'}"
                        placeholder="Configuración Vehicular SCT" optionLabel="clv_nomenclatura" [showClear]="true"
                        formControlName="id_conf_veh_sct" optionValue="idx" tooltip="Configuración Vehicular SCT"
                        tooltipPosition="top"></p-dropdown>
                      <hr class="my-0">
                    </div>
                  </div>
                </div>
              </div>

              <div class="row" *ngIf="this.formularioUnidad.get('clave_configuracionUnidad')?.value == 10">
                <div class="form-group col-md-6" >
                  <div class="row">
                    <div class="col-sm-4 mx-0 d-flex align-items-center mt-2">
                      <span class="input-group-addon"> <i class="pi pi-truck color-icon" style="font-size: 1.7rem"></i>
                      </span>
                      <small class="color-icon mt-3 ml-2"
                        style="display: inline-block; font-weight: bold;">Lleva Caja?</small>
                    </div>
                    <div class="col-sm-8">
                      <p-dropdown [options]="lstSituacion" autoWidth="false" [style]="{'width':'100%'}"
                      placeholder="Lleva Caja?" optionLabel="nombre" [showClear]="true"
                      formControlName="val_llevaCaja" optionValue="id" tooltip="Lleva Caja?"
                      tooltipPosition="top"></p-dropdown>
                      <hr class="my-0">
                    </div>
                  </div>
                </div>
                <div class="form-group col-md-6">
                  <div class="row">
                    <!-- <div class="col-sm-1"><span class="input-group-addon"> <i class="pi pi-book color-icon"
                          style="font-size: 2rem"></i>
                      </span></div> -->
                    <div class="col-sm-4 mt-2">
                      <button class="btn btn-warning form-control" type="button" 
                        [disabled]="valAdminCajas()"
                        (click)="adminCajas()">
                        <span class="text-white">Administrar Cajas</span>
                      </button>
                      <hr class="my-0">
                    </div>
                  </div>
                </div>
              </div>

              <div class="row d-flex justify-content-center mt-4">
                <div class="col-4">
                  <p *ngIf="!formularioUnidad.valid" class="texto-invalido text-right">
                    <i class="pi pi-info-circle" style="font-size: 1.5rem;">Es Necesario
                      Proporcionar La Informaci&oacute;n Obligatoria(*)</i>
                  </p>
                  <p *ngIf="formularioUnidad.valid" class="texto-valido text-right">
                    <i class="pi pi-check-circle" style="font-size: 1.5rem;">Informaci&oacute;n
                      Completa</i>
                  </p>
                </div>
                <div class="col-2">
                  <button type="submit" class="btn btn-success form-control" [disabled]="!formularioUnidad.valid">
                    <span class="text-white">Guardar</span>
                    <i class="pi pi-save text-white"></i>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </ng-template>
      <ng-template pTemplate="footer">
        <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text"
          (click)="cancelarVentanaOperacion()"></button>
      </ng-template>
    </p-dialog>
    <!--ASIGNACION DE ESTATUS-->
    <p-dialog [resizable]="false" [draggable]="false" [(visible)]="dspEstatus"
      [style]="{'width': '60vw','height':'530px'}" [transitionOptions]="'0ms'" styleClass="card-shadow"
      (onHide)="cancelarModal()">
      <ng-template pTemplate="header">
        Administración de Estatus y Sub-Estatus
      </ng-template>
      <ng-template pTemplate="content">
        <div class="mt-5">
          <form [formGroup]="dataForm" (ngSubmit)="guardarInformacionEstatus()">
            <span class="title-light mt-3">Información de Estatus de Unidad {{num_economico_general}}<i
                class="pi pi-cog" style="size: 2rem;"></i>
            </span>
            <div class="row mt-3">
              <div class="form-group col-md-6">
                <div class="row g-0">
                  <div class="col-sm-2 d-flex align-items-center">
                    <span class="input-group-addon"> <i class="pi pi-bars color-icon" style="font-size: 1.5rem"></i>
                    </span>
                  </div>
                  <div class="col-sm-10">
                    <p-dropdown [options]="lstEstatusUnidad" optionLabel="desc_estatus" autoWidth="false"
                      [style]="{'width':'100%'}" [showClear]="true" formControlName="clv_estatus"
                      optionValue="clv_estatus" placeholder="Seleccione Estatus*" tooltip="Estatus"></p-dropdown>
                    <hr class="my-0">
                  </div>
                </div>
              </div>
              <div class="form-group col-md-6">
                <div class="row g-0">
                  <div class="col-sm-2 d-flex align-items-center">
                    <span class="input-group-addon"> <i class="pi pi-bars color-icon" style="font-size: 1.5rem"></i>
                    </span>
                  </div>
                  <div class="col-sm-10">
                    <p-dropdown [options]="lstSubEstatusUnidad" optionLabel="desc_sub_estatus" autoWidth="false"
                      [style]="{'width':'100%'}" [showClear]="true" formControlName="clv_sub_estatus"
                      optionValue="clv_sub_estatus" placeholder="Seleccione Sub-Estatus*"
                      tooltip="Sub-Estatus"></p-dropdown>
                    <hr class="my-0">
                  </div>
                </div>
              </div>
            </div>
            <div class="row d-flex justify-content-center mt-5">
              <div class="col-2">
                <button type="submit" class="btn btn-success w-100" [disabled]="!dataForm.valid || habilitar_edicion">
                  <span class="text-white">Aceptar</span>
                  <i class="pi pi-save text-white"></i>
                </button>
              </div>
            </div>
          </form>
          <div class="row d-flex justify-content-end mb-5">
            <div class="col-md-3">
              <button class="btn btn-warning w-100" (click)="habilitarEdicion();"
                pTooltip="Habilitar campos para actualizar Información.">
                <span>Habilitar Edición</span>
                <i class="pi pi-eraser"></i>
              </button>
            </div>
          </div>
        </div>
      </ng-template>
      <ng-template pTemplate="footer">
        <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text"
          (click)="cancelarModal();"></button>
      </ng-template>
    </p-dialog>
    <!--REPORTES-->
    <p-dialog [resizable]="false" [draggable]="false" [(visible)]="dbsReportes"
      [style]="{'width': '60vw','height':'620px'}" [transitionOptions]="'0ms'" styleClass="card-shadow"
      (onHide)="cancelarModalReportes()">
      <ng-template pTemplate="header">
        Reportes
      </ng-template>
      <ng-template pTemplate="content">
        <div class="mt-5">
          <div class="row">
            <div class="col-md-4">
              <p class="texto-pesado">Tasa de Ocupación (Inicio y Fin)</p>
            </div>
            <div class="col-md-3">
              <input type="date" class="form-control sinborde" pTooltip="Seleccione o teclee fecha inicio"
                tooltipPosition="top" [(ngModel)]="fecha_rpt_uso_unidad_inicio">
              <hr class="my-0">
            </div>
            <div class="col-md-3">
              <input type="date" class="form-control sinborde" pTooltip="Seleccione o teclee fecha fin"
                tooltipPosition="top" [(ngModel)]="fecha_rpt_uso_unidad_fin">
              <hr class="my-0">
            </div>
            <div class="col-md-2">
              <button type="button" class="btn btn-outline-success" style="width: 100%;"
                (click)="  exportarRptUsoPorUnidad()" [disabled]="valUsoPorUnidad()">
                Exportar <i class="pi pi-file-export"></i>
              </button>
            </div>
            <div class="row d-flex justify-content-center">
              <div class="col-2 text-center">
                <i class="pi pi-spin pi-spinner" *ngIf="ldng_usoPor_unidad"></i>
              </div>
            </div>
		</div>
    <hr class="style-two">
          <div class="row">
            <div class="col-md-4">
              <p class="texto-pesado">Todas las Unidades</p>
            </div>
            <div class="col-md-2">
              <button type="button" class="btn btn-outline-success" style="width: 100%;" (click)="exportarExcel()">
                Exportar <i class="pi pi-file-export"></i>
              </button>
            </div>
          </div>
          <hr class="style-two">
          <div class="row">
            <div class="col-md-4">
              <p class="texto-pesado">Unidades: Dias Prestados y Total Servicios (Mes y Año)</p>
            </div>
            <div class="col-md-3">
              <p-dropdown [options]="meses" optionLabel="nombre" placeholder="Mes*" autoWidth="false"
                [style]="{'width':'100%'}" [showClear]="true" [(ngModel)]="selectedMes" tooltip="Es el Mes a consultar"
                tooltipPosition="left"></p-dropdown>
            </div>
            <div class="col-md-3">
              <p-calendar [(ngModel)]="anio" [showIcon]="true" view="year" dateFormat="yy" [style]="{'width':'100%'}"
                placeholder="Seleccione un año*"></p-calendar>
            </div>
            <div class="col-md-2">
              <button type="button" class="btn btn-outline-success" style="width: 100%;" (click)="exportarExcelTDO()">
                Exportar <i class="pi pi-file-export"></i>
              </button>
            </div>
          </div>
          <hr class="style-two">
          <div class="row">
            <div class="col-md-4">
              <p class="texto-pesado">Unidades: Días Prestados y Total Servicios por Rango de Fechas</p>
            </div>
            <div class="col-md-3">
              <input type="date" class="form-control sinborde" pTooltip="Seleccione o teclee fecha inicio"
                tooltipPosition="top" [(ngModel)]="fecha_rpt_dias">
              <hr class="my-0">
            </div>
            <div class="col-md-3">
              <input type="date" class="form-control sinborde" pTooltip="Seleccione o teclee fecha fin"
                tooltipPosition="top" [(ngModel)]="fecha_fin_rpt_dias">
              <hr class="my-0">
            </div>
            <div class="col-md-2">
              <button type="button" class="btn btn-outline-success" style="width: 100%;"
                (click)="exportarRptDiasFecha()">
                Exportar <i class="pi pi-file-export"></i>
              </button>
            </div>
          </div>
          <hr class="style-two">
          <div class="row">
            <div class="col-md-4">
              <p class="texto-pesado">Unidades Detallado: Total Servicios por Rango de Fechas</p>
            </div>
            <div class="col-md-3">
              <input type="date" class="form-control sinborde" pTooltip="Seleccione o teclee fecha inicio"
                tooltipPosition="top" [(ngModel)]="fecha_rpt_detallado">
              <hr class="my-0">
            </div>
            <div class="col-md-3">
              <input type="date" class="form-control sinborde" pTooltip="Seleccione o teclee fecha fin"
                tooltipPosition="top" [(ngModel)]="fecha_fin_rpt_detallado">
              <hr class="my-0">
            </div>
            <div class="col-md-2">
              <button type="button" class="btn btn-outline-success" style="width: 100%;"
                (click)="  exportarRptTasaOcupacionDetalladoFecha()">
                Exportar <i class="pi pi-file-export"></i>
              </button>
            </div>
          </div>
          <hr class="style-two">
          <div class="row">
            <div class="col-md-4">
              <p class="texto-pesado">Histórico de Estatus de Unidades (Mes y Año)</p>
            </div>
            <div class="col-md-3">
              <p-dropdown [options]="meses" optionLabel="nombre" placeholder="Mes*" autoWidth="false"
                [style]="{'width':'100%'}" [showClear]="true" [(ngModel)]="selectedMesHistorico"
                tooltip="Es el Mes a consultar y/o Todos" tooltipPosition="left"></p-dropdown>
            </div>
            <div class="col-md-3">
              <p-calendar [(ngModel)]="anio_historico" [showIcon]="true" view="year" dateFormat="yy"
                [style]="{'width':'100%'}" placeholder="Seleccione un año*"></p-calendar>
            </div>
            <div class="col-md-2">
              <button type="button" class="btn btn-outline-success" style="width: 100%;"
                (click)="exportarExcelHistorico()">
                Exportar <i class="pi pi-file-export"></i>
              </button>
            </div>
          </div>
          <hr class="style-two">
          <div class="row">
            <div class="col-md-4">
              <p class="texto-pesado">Histórico de Estatus de Unidades Por Rango de Fechas
              </p>
            </div>
            <div class="col-md-3">
              <input type="date" class="form-control sinborde" pTooltip="Seleccione o teclee fecha inicio"
                tooltipPosition="top" [(ngModel)]="fecha_rpt_historico">
              <hr class="my-0">
            </div>
            <div class="col-md-3">
              <input type="date" class="form-control sinborde" pTooltip="Seleccione o teclee fecha fin"
                tooltipPosition="top" [(ngModel)]="fecha_fin_rpt_historico">
              <hr class="my-0">
            </div>
            <div class="col-md-2">
              <button type="button" class="btn btn-outline-success" style="width: 100%;"
                (click)="exportarRptHistoricoFechas()">
                Exportar <i class="pi pi-file-export"></i>
              </button>
            </div>
          </div>
          <hr class="style-two">
          <div class="row">
            <div class="col-md-4">
              <p class="texto-pesado">Contabilizar Inactividad de Unidad (Mes y Año)</p>
            </div>
            <div class="col-md-3">
              <p-dropdown [options]="meses" optionLabel="nombre" placeholder="Mes*" autoWidth="false"
                [style]="{'width':'100%'}" [showClear]="true" [(ngModel)]="selectedMesHistoricoIna"
                tooltip="Es el Mes a consultar y/o Todos" tooltipPosition="left"></p-dropdown>
            </div>
            <div class="col-md-3">
              <p-calendar [(ngModel)]="anio_historico_ina" [showIcon]="true" view="year" dateFormat="yy"
                [style]="{'width':'100%'}" placeholder="Seleccione un año*"></p-calendar>
            </div>
            <div class="col-md-2">
              <button type="button" class="btn btn-outline-success" style="width: 100%;"
                (click)="exportarExcelHistoricoIna()">
                Exportar <i class="pi pi-file-export"></i>
              </button>
            </div>
          </div>
          <hr class="style-two">
          <div class="row">
            <div class="col-md-4">
              <p class="texto-pesado">Control General De Unidades Completo</p>
            </div>
            <div class="col-md-2">
              <button type="button" class="btn btn-outline-success" style="width: 100%;"
                (click)="exportarExcelGeneralUnidades()">
                Exportar <i class="pi pi-file-export"></i>
              </button>
            </div>
          </div>
        </div>
      </ng-template>
      <ng-template pTemplate="footer">
        <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text"
          (click)="cancelarModalReportes();"></button>
      </ng-template>
    </p-dialog>
    <!--Herramientas de Recursos-->
    <p-dialog [resizable]="false" [draggable]="false" [(visible)]="dsbHerramientas"
      [style]="{'width': '60vw','height':'600px'}" [transitionOptions]="'0ms'" styleClass="card-shadow"
      (onHide)="cancelarModalHerramientas()">
      <ng-template pTemplate="header">
        Herramientas de Recursos
      </ng-template>
      <ng-template pTemplate="content">
        <div class="mt-5">
          <form [formGroup]="herramientasForm" (ngSubmit)="guardarInformacionHerramientas()">
            <span class="title-light mt-3">Información de la Unidad<i class="pi pi-cog" style="size: 2rem;"></i>
            </span>
            <div class="row mt-3">
              <div class="form-group col-md-6">
                <div class="row g-0">
                  <div class="col-sm-6 d-flex align-items-center">
                    <span class="input-group-addon"> <i class="pi pi-truck color-icon" style="font-size: 1.5rem"></i>
                      <p class="ml-1 color-icon d-inline">Economico</p>
                    </span>
                  </div>
                  <div class="col-sm-6">
                    <input type="text" class="form-control sinborde" formControlName="num_economico"
                      style="text-transform:uppercase; font-weight: bold;" pTooltip="Economico">
                    <hr class="my-0">
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-3">
              <div class="form-group col-md-6">
                <div class="row g-0">
                  <div class="col-sm-6 d-flex align-items-center">
                    <span class="input-group-addon"> <i class="pi pi-credit-card color-icon"
                        style="font-size: 1.5rem"></i>
                      <p class="ml-1 color-icon d-inline">Fijo</p>
                    </span>
                  </div>
                  <div class="col-sm-6">
                    <input type="text" class="form-control sinborde" placeholder="Tag Fijo*"
                      formControlName="num_tag_fijo" style="text-transform:uppercase;" pTooltip="Fijo">
                    <hr class="my-0">
                  </div>
                </div>
              </div>
              <div class="form-group col-md-6">
                <div class="row g-0">
                  <div class="col-sm-12 d-flex align-items-center">
                    <small *ngIf="herramientasForm.controls['num_tag_fijo'].invalid" style="color: red;">
                      *Obligatorio 4 digitos. Solo Numeros.
                    </small>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-3">
              <div class="form-group col-md-6">
                <div class="row g-0">
                  <div class="col-sm-6 d-flex align-items-center">
                    <span class="input-group-addon"> <i class="pi pi-credit-card color-icon"
                        style="font-size: 1.5rem"></i>
                      <p class="ml-1 color-icon d-inline">Emergente</p>
                    </span>
                  </div>
                  <div class="col-sm-6">
                    <input type="text" class="form-control sinborde" placeholder="Tag Emergente"
                      formControlName="num_tag_emergente" style="text-transform:uppercase;" pTooltip="Emergente">
                    <hr class="my-0">
                  </div>
                </div>
              </div>
              <div class="form-group col-md-6">
                <div class="row g-0">
                  <div class="col-sm-12 d-flex align-items-center">
                    <small *ngIf="herramientasForm.controls['num_tag_emergente'].invalid" style="color: red;">
                      *Obligatorio 4 digitos. Solo Numeros.
                    </small>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-3">
              <div class="form-group col-md-6">
                <div class="row g-0">
                  <div class="col-sm-6 d-flex align-items-center">
                    <span class="input-group-addon"> <i class="pi pi-credit-card color-icon"
                        style="font-size: 1.5rem"></i>
                      <p class="ml-1 color-icon d-inline">Sodexo</p>
                    </span>
                  </div>
                  <div class="col-sm-6">
                    <input type="text" class="form-control sinborde" placeholder="Tarjeta Sodexo*"
                      formControlName="num_tarjeta_sodexo" style="text-transform:uppercase;" pTooltip="Sodexo">
                    <hr class="my-0">
                  </div>
                </div>
              </div>
              <div class="form-group col-md-6">
                <div class="row g-0">
                  <div class="col-sm-12 d-flex align-items-center">
                    <small *ngIf="herramientasForm.controls['num_tarjeta_sodexo'].invalid" style="color: red;">
                      *Obligatorio 4 digitos. Solo Numeros.
                    </small>
                  </div>
                </div>
              </div>
            </div>
            <div class="row d-flex justify-content-center mt-5">
              <div class="col-2">
                <button type="submit" class="btn btn-success w-100"
                  [disabled]="!herramientasForm.valid || habilitar_edicion_herramientas">
                  <span class="text-white">Aceptar</span>
                  <i class="pi pi-save text-white"></i>
                </button>
              </div>
            </div>
          </form>
          <div class="row d-flex justify-content-end mb-5">
            <div class="col-md-3">
              <button class="btn btn-warning w-100" (click)="habilitarEdicionHerramientas();"
                pTooltip="Habilitar campos para actualizar Información.">
                <span>Habilitar Edición</span>
                <i class="pi pi-eraser"></i>
              </button>
            </div>
          </div>
        </div>
      </ng-template>
      <ng-template pTemplate="footer">
        <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text"
          (click)="cancelarModalHerramientas();"></button>
      </ng-template>
    </p-dialog>
    <!--Registro de kilometraje de mantenimiento-->
    <p-dialog [resizable]="false" [draggable]="false" [(visible)]="kmHistory" (onHide)="cancelarModal()">
      <ng-template pTemplate="header">
        Gestión de Kilometrajes de Mantenimiento
      </ng-template>
      <ng-template pTemplate="content">
        <br>
        <table style="width: 100%;">
          <tr>
            <td>Ultimo kilometraje</td>
            <td><input id="input_ultimo_kilometraje_ingresado" class="form-control" type="number" min="0" disabled></td>
            <td>&nbsp;&nbsp;<b>Numero Economico:</b></td>
            <td style="color: rgb(78, 200, 213); font-size: 25px;"><b>&nbsp;{{this.unidadTransporte.num_economico}}</b></td>
            <td></td>
          </tr>
          <tr>
            <td>{{kmLabelKilm}}</td>
            <td><input id="input_nuevo_kilometraje" class="form-control" type="number" min="0"
                (keypress)="validateNumberKilometraje($event)" (paste)="validatePasteKilometraje($event)"></td>
            <td>&nbsp;&nbsp;{{kmLabelFecha}}</td>
            <td><input id="input_nueva_fecha_mantenimiento" class="form-control" type="date"  [disabled]="kmInputFecha"></td>
            <td>&nbsp;&nbsp;<button type="button" pButton (click)="confirmarMensaje()" label="{{kmLabelButtonKilm}}"
                (click)="confirmacionKilometrajeMostrar()" class="p-button-success"></button></td>
          </tr>
        </table>
        <br>

        <div style="border: 1px solid #ccc !important;">
          <p-table [value]="historicoMUnit" class="dtCustom" [tableStyle]="{'width': '100%'}"
          [paginator]="true" [rows]="5" [rowsPerPageOptions]="[5,10,25,50,100,150,200]">
            <ng-template pTemplate="caption">
              <div class="flex align-items-center justify-content-between">
                Historico de Kilometrajes de mantenimiento
              </div>
            </ng-template>
            <ng-template pTemplate="header">
            </ng-template>
            <ng-template pTemplate="body" let-history>
              <tr>
                <td>{{history.km_mantenimiento}} km</td>
                <td>{{history.fecha_mantenimiento | date:'dd/MM/yyyy'}}</td>
                <td *ngIf="kmInputFecha"><p-tag value="Estas editando actualmente" [hidden]="history.final != 1" /></td>
                <td style="text-align: right;">

                  <div *ngIf="!edi">
                    <button pButton class="p-button-warning btn-sm" icon="pi pi-pencil" pTooltip="Editar"
                    (click)="editarKilometraje(history)" [hidden]="history.final != 1"></button>
                  &nbsp;&nbsp;<button pButton class="p-button-danger btn-sm" icon="pi pi-times" pTooltip="Eliminar"
                    (click)="eliminarKilometrajeMostrar(history)"></button>
                  </div>
                  <div *ngIf="edi">
                    <button pButton class="p-button-help btn-sm" icon="pi pi-replay" pTooltip="Cancelar Editar"
                    (click)="cancelareditar(history)" [hidden]="history.final != 1"></button>
                  &nbsp;&nbsp;<button pButton class="p-button-danger btn-sm" icon="pi pi-times" pTooltip="Eliminar"
                    (click)="eliminarKilometrajeMostrar(history)"></button>
                  </div>
                </td>

              </tr>
            </ng-template>
          </p-table>
        </div>

      </ng-template>
      <ng-template pTemplate="footer">
        <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text"
          (click)="cancelarModal()"></button>
      </ng-template>
    </p-dialog>
    <p-dialog [resizable]="false" [draggable]="false" [(visible)]="confirmacionkmActualizacion"
      (onHide)="confirmacionKilometrajeOcultar()">
      <ng-template pTemplate="content">
        <div class="mt-5">
          <h3 class="text-center">¿Estas Seguro que deseas guardar la Informacion?</h3>
        </div>
      </ng-template>
      <ng-template pTemplate="footer">
        <button pButton label="Cancelar" icon="pi pi-times" class="p-button-danger p-button-text"
          (click)="confirmacionKilometrajeOcultar()"></button>
        <button pButton label="Continuar" icon="pi pi-check" class="p-button-success"
          (click)="actualizarKilometraje()"></button>
      </ng-template>
    </p-dialog>
    <p-dialog [resizable]="false" [draggable]="false" [(visible)]="confirmacionkmEliminacion"
      (onHide)="confirmacionKilometrajeOcultar()">
      <ng-template pTemplate="content">
        <div class="mt-5">
          <h3 class="text-center">¿Estas Seguro que deseas eliminar la información?</h3>
        </div>
      </ng-template>
      <ng-template pTemplate="footer">
        <button pButton label="Cancelar" icon="pi pi-times" class="p-button-danger p-button-text"
          (click)="confirmacionKilometrajeOcultar()"></button>
        <button pButton label="Continuar" icon="pi pi-check" class="p-button-success"
          (click)="eliminarKilometraje()"></button>
      </ng-template>
    </p-dialog>
    <p-dialog [resizable]="false" [draggable]="false" [(visible)]="gestCajas"
       [style]="{ 'width': '70vw','height':'90vh' }" (onHide)="cancelGestCajas()">
        <ng-template pTemplate="header">
          Gestion Cajas
        </ng-template>
        <ng-template pTemplate="content">
          <div class="d-flex justify-content-start text-center texto-pesado  mt-5">
            <div class="col-md-4">Numero Economico: {{selectedUnidad.num_economico}}</div>
            <!-- <div class="col-md-6">Proveedor: {{.proveedor}}</div> -->
          </div>
          <div class="row d-flex justify-content-centert">
            <div class="col-md-12">
              <ng-container *ngTemplateOutlet="templateTabGestCajas; context:{l:selectedUnidad.lstRelCajas,t:1,a:'Cajas',b:1}"> 
              </ng-container>
              <!-- <ng-container *ngTemplateOutlet="templateTabFechas; context:{l:lstFechasGPS_baja,t:1,a:'GPS',b:2}"> 
              </ng-container> -->
            </div>
            <!-- <div class="col-md-6">
              <ng-container *ngTemplateOutlet="templateTabFechas; context:{l:lstFechasCamara,t:2,a:'Camaras',b:1}"> 
              </ng-container>
              <ng-container *ngTemplateOutlet="templateTabFechas; context:{l:lstFechasCamara_baja,t:2,a:'Camaras',b:2}"> 
              </ng-container>
            </div> -->
          </div>
        </ng-template>
        <ng-template #templateTabGestCajas let-cajas="l" let-Type="t" let-ContextHead="a" let-accion="b">
          <div class="mt-5 mb-5">
            <form class="formValCaja" [formGroup]="formValCaja">
              <p-table [value]="cajas" class="dtCustom" [loading]="loadingCajas">
                <ng-template pTemplate="caption">
                  <div class="flex align-items-center justify-content-between">
                    <p class="mr-2 ml-5 fs-5 color-header">{{ContextHead+' Asignadas'}}</p>
                      <div class="row ml-12" *ngIf="accion==1">                    
                          <div class="flex">
                            <div class="mr-5">
                              <input type="text" class="form-control sinborde" placeholder="Ingrese Placa*"
                                formControlName="placa" style="text-transform:uppercase; color: blueviolet;"
                                pTooltip="placa" tooltipPosition="top">              
                            </div>
                            <div class="mr-1">
                              <p-dropdown [options]="lstSubTipoRem" optionLabel="clv_tipo_remolque" autoWidth="false"
                                [style]="{'width':'100%'}" [showClear]="true" formControlName="id_tipoRem"
                                optionValue="idx" placeholder="Seleccione Tipo Remolque*"
                                pTooltip="Tipo Remolque" tooltipPosition="left"></p-dropdown>
                            </div>
                            <div class="col" *ngIf="flg_edit==false">  
                              <button pButton class="p-button-success btn-sm"
                              icon="pi pi-plus-circle"
                              pTooltip="Agregar Remolque" tooltipPosition="top"
                              (click)="agregaCaja()"
                              [disabled]="valHabilitaRem()||!formValCaja.valid||!formValCaja.controls['add'].value"></button>
                            </div>
                            <div class="col" *ngIf="flg_edit==true">  
                              <button pButton class="p-button-warning btn-sm"
                              icon="pi pi-pencil"
                              pTooltip="Editar Remolque" tooltipPosition="top"
                              (click)="editaCaja()"
                              [disabled]="!formValCaja.valid||!formValCaja.controls['add'].value"></button>
                            </div>
                            <div class="col" *ngIf="flg_edit==true">  
                              <button pButton class="p-button-danger btn-sm"
                              icon="pi pi-times-circle"
                              pTooltip="Cancela Edicion" tooltipPosition="top"
                              (click)="cancelEditaCaja()"
                              [disabled]="!formValCaja.valid||!formValCaja.controls['add'].value"></button>
                            </div>
                            <!-- <div class="col">
                              <button pButton class="p-button-primary btn-sm"
                              icon="pi pi-refresh"
                              pTooltip="Revertir {{ContextHead}}"
                              (click)="revertChangesCajas(true)"></button>
                            </div> -->
                              <div class="col" *ngIf="!valHabilitaRem()">
                                <p-toggleButton class="tbCustom" [style]="{'width':'100%'}"
                                  formControlName="add" 
                                  pTooltip="Habilitar/Deshabilitar Edición"
                                  onLabel="ON" offLabel="OFF" styleClass="p-button-primary sm-3"/>
                                <!-- <p-togglebutton [disabled]="true" onIcon="pi pi-times" offIcon="pi pi-times" 
                                  formControlName="add" onLabel="Deshabilitado" offLabel="Habilitado" 
                                  ariaLabel="Habilitar Agregar" /> -->

                            </div>
                          </div>
                      </div>
                  </div>
                </ng-template>
                <ng-template pTemplate="header" *ngIf="accion == 1">
                    <tr class="mt-5">
                        <th>Placa</th>
                        <th>Clave Tipo Remolque</th>
                        <th>Fecha de Asignación</th>
                        <th>Estatus</th>
                        <th *ngIf="accion == 1"> Acción </th>                      
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-cajas>
                    <tr
                    [ngClass]="{'row-accessories': cajas.clv_activo==0,'row-baja':cajas.clv_activo==2||cajas.idx==0,'texto_sm':true}">
                    <!-- [ngClass]="{'row-accessories': unidad.clv_estatus===0,'row-baja': unidad.clv_estatus==3,'texto_sm':true}" -->
                        <!-- <td>{{cajas.fecha_asignacion | date:'dd/MM/YYYY'}}</td> -->
                        <!-- <td>{{ContextHead+'_'+cajas.id_tipo}}</td> -->
                        <td>{{cajas.placa}}</td>
                        <td>{{cajas.clv_tipo_remolque}}</td>
                        <td>{{cajas.fecha_asignacion}}</td>
                        <td *ngIf="cajas.clv_activo==2">{{cajas.desc_estatus}} - Editado: Sin Guardar</td>
                        <td *ngIf="cajas.clv_activo!=2&&cajas.idx!=0">{{cajas.desc_estatus}}</td>
                        <td *ngIf="cajas.idx==0">{{cajas.desc_estatus}} - Agregado: Sin Guardar</td>
                        <td *ngIf="accion == 1">
                          <button *ngIf="cajas.idx != 0" pButton class="p-button-warning btn-sm ml-2"
                          icon="pi pi-pencil"
                          pTooltip="Editar"
                          (click)="modRem(cajas.idx)"></button>
                          <button *ngIf="cajas.idx != 0" pButton class="p-button-info btn-sm ml-2"
                          icon="{{cajas.clv_acitvo==2?'pi pi-star':cajas.clv_activo==1?'pi pi-star-fill':'pi pi-star'}}"
                          pTooltip="{{cajas.clv_acitvo==2?'En Modificacion':cajas.clv_activo==1?'Activo':'Inactivo'}}"
                          (click)="updateStatus(cajas.idx)"></button>
                        <!-- <button pButton class="p-button-secondary btn-sm ml-2"
                          icon="pi pi-times-circle"
                          pTooltip="Desactivar"
                          (click)="earseCaja(cajas.idx)"></button> -->
                        <button pButton class="p-button-danger btn-sm ml-2"
                          icon="pi pi-times-circle"
                          pTooltip="Desasignar"
                          (click)="earseCaja(cajas.idx,cajas.placa)"></button>
                        </td>
                    </tr>
                </ng-template>
              </p-table>
            </form>
          </div>
        </ng-template>
        <ng-template pTemplate="footer">
          <div class="row d-flex justify-content-center mt-4">
            <div class="col-6">
              <p *ngIf="this.valHabilitaRem()" class="texto-invalido text-right">
                <i class="pi pi-info-circle" style="font-size: 1.5rem;">Solo es posible asignar hasta 2 cajas Activas(*)</i>
              </p>
              <!-- <p *ngIf="formularioUnidad.valid" class="texto-valido text-right">
                <i class="pi pi-check-circle" style="font-size: 1.5rem;">Informaci&oacute;n
                  Completa</i>
              </p> -->
            </div>
          </div> 
          <!-- <button pButton label="Cancelar" icon="pi pi-times" class="p-button-danger p-button-text"
          (click)="cancelGestCajas()"
          ></button> -->
          <button pButton label="Guardar" icon="pi pi-check" class="p-button-success" 
            [disabled]="!dirtyList&&this.selectedUnidad.lstRelCajas.length!=0" (click)="saveCajas()"
          ></button>
        </ng-template>
      </p-dialog>
  </div>

   <p-dialog [resizable]="false" [draggable]="false" [(visible)]="dspPermisoMtto" 
      [style]="{'width': '75vw','height':'100vh'}" [transitionOptions]="'0ms'" styleClass="card-shadow"
      (onHide)="cancelarModalPermisoMtto()">
      <ng-template pTemplate="header">
        Gesti&oacute;n Permisos Mantenimiento
      </ng-template>
      <ng-template pTemplate="content">
          
          <div class="container-fluid">
            <div class="row full-height">
              <div class="col-5 panel">
                <form [formGroup]="permisoMttoForm" (ngSubmit)="guardarPermisoMtto()">
                  <div class="row form-group g-0d-flex align-items-center">
                    <div class="col-sm-4">
                      <span class="input-group-addon"> 
                        <i class="pi pi-truck color-icon" style="font-size: 1.5rem;"></i>
                        <p class="ml-1 color-icon d-inline"><b>Economico</b></p>
                      </span>
                    </div>
                    <div class="col-sm-6">
                      <input type="text" class="form-control sinborde" 
                        placeholder="Numero Económico*"
                        formControlName="num_economico" [disabled] ="true"
                        style="text-transform:uppercase;">
                      <hr class="my-0">
                    </div>
                  </div>
                  <div class="row d-flex align-items-center mt-3 mb-2">
                    <div class="col-sm">
                      <span class="title-light ">Información de para registro de permiso
                        <i class="pi pi-cog" style="size: 2rem;"></i>
                      </span>
                    </div>
                  </div>
                  <div class="row d-flex align-items-center mt-3 mb-2">
                    <div class="row form-group g-0d-flex align-items-center">
                      <div class="col-sm-4">
                        <span class="input-group-addon"> 
                          <i class="pi pi-calendar color-icon" style="font-size: 1.5rem;"></i>
                          <p class="ml-1 color-icon d-inline"><b>Permiso</b></p>
                        </span>
                      </div>
                      <div class="col-sm-6">
                          <p-calendar formControlName="fecha" 
                            [showIcon]="true" dateFormat="dd/mm/yy"
                            placeholder="Fecha Permiso"
                            [appendTo]="'body'"
                            [style]="{'width':'100%','font-weight':'bold'}"
                            pTooltip="Ingresar Fecha"></p-calendar>
                        <hr class="my-0">
                      </div>
                    </div>
                  </div>
                  <div class="row d-flex align-items-center mt-3 mb-2">
                    <div class="row form-group g-0d-flex align-items-center">
                      <div class="col-sm-12">
                        <span class="input-group-addon"> 
                          <i class="pi pi-tag color-icon" style="font-size: 1.5rem;"></i>
                          <p class="ml-1 color-icon d-inline"><b>Observación</b></p>
                        </span>
                      </div>
                      <div class="col-sm-12">
                        <textarea 
                            id="txt-area-permiso" 
                            rows="5" cols="50" 
                            pInputTextarea
                            formControlName="dsc_info"
                            [autoResize]="true">
                        </textarea>
                      </div>
                    </div>
                  </div>
                  <div class="row d-flex justify-content-arround">
                    <div class="row form-group g-0d-flex align-items-center">
                      <div class="col">
                        <p-button
                            icon="pi pi-verified" styleClass="p-button-success p-button-sm" type="submit"
                            label="Registrar de Permiso" [disabled]="!this.permisoMttoForm.valid"
                            pTooltip="Registrar Permiso" tooltipPosition="top">
                        </p-button>
                        <!-- [disabled]="!this.permisoMttoForm.valid" -->
                      </div>
                      <div class="col">
                        <p-button
                            icon="pi pi-times-circle" styleClass="p-button-sm" (click)="cancelarModalPermisoMtto()"
                            label="Cancelar" pTooltip="Duplicar Información de Origen a Destino" tooltipPosition="top">
                        </p-button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>              
              <div class="col-7 panel bg-white">
                <!-- <p class="mr-2 fs-4 color-header">Historico de Permisos</p> -->
                 <!-- <div class="col-sm-6 "> -->
                <div class="row justify-content-end mb-2 mr-3">
                  <div class="col-sm-2 mb-2">
                    <p-button
                        icon="pi pi-verified" styleClass="p-button-sm" (click)="revHistMtto()" 
                        label="Historico" 
                        pTooltip="Visualizar historico Permisos" tooltipPosition="left">
                    </p-button>
                  </div>
                </div>
                <!-- </div> -->
                <p-table #dt1 [value]="lstPermisosMtto" [tableStyle]="{'min-width': 'auto','min_height':'20vh'}"
                  styleClass="p-datatable-sm p-datatable-striped" [scrollable]="true" scrollHeight="40vh"
                  [globalFilterFields]="['num_economico','dsc_info']" [paginator]="true" [rows]="50"
                  [rowsPerPageOptions]="[25,50,100,150,200]" [loading]="loadingPermisosMtto" [showCurrentPageReport]="true"
                  [resizableColumns]="true" currentPageReportTemplate=" {first} a {last} de {totalRecords} Registros">
                  <ng-template pTemplate="caption">
                    <div class="flex">
                      <p-columnFilter field="clv_estatus" matchMode="equals" [showMenu]="false">
                        <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                          <p-dropdown [ngModel]="value" [options]="lstEstatus" optionLabel="nombre" optionValue="id"
                            (onChange)="filter($event.value)" placeholder="Filtrar por Estatus" [showClear]="true">
                          </p-dropdown>
                        </ng-template>
                      </p-columnFilter>
                      <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" size="20" (input)="applyFilterGlobal($event, 'contains')"
                          placeholder="Buscar Fecha, Observación"/>
                      </span>
                    </div>
                  </ng-template>
                  <ng-template pTemplate="header">
                    <tr>
                      <th class="text-center" >#Economico</th>
                      <th class="text-center"
                        style="min-width:auto ;max-width: auto;" >
                        fecha
                        <p-sortIcon field="fecha"></p-sortIcon>
                      </th>
                      <th style="min-width:180px ;max-width: 180px;">
                        Observaci&oacute;n
                      </th>
                      <th style="min-width:180px;max-width: 180px;"></th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-permiso>
                    <tr
                      [ngClass]="{'row-accessories': permiso.clv_estatus==1
                        ,'row-baja': permiso.clv_estatus==0,'texto_sm':false}">
                      <td [ngClass]="{'color-numeconomico':true}">
                        <p class="text-center">{{permiso.num_economico}}</p>
                      </td>
                      <td class="text-center">{{permiso.fecha}}</td>
                      <td [ngClass]="{'color-sombreado':true}">{{permiso.dsc_info}}</td>
                      <td>
                        <div class="btnGrp">
                          <p-button 
                            styleClass="p-button-danger p-button-sm" 
                            pTooltip="Elimnar Permiso Mtto" tooltipPosition="top"
                            (click)="editarPermiso(permiso);"
                            icon="pi pi-times-circle"/>
                        </div>
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </div>
          </div>
    </ng-template>
  </p-dialog>
